
import { useEffect, useState } from "react"
import url from "../api/url"
import { elToast } from "../functions/Alerta"
import { useEmpleadoStore } from "../stores/useEmpleadoStore"

const useContactosEmergencia = () => {

    // variables
    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const contactoInicial = {
        funcion: 'guardarContacto',
        nombre: '',
        telefono: '',
        correo: objLogueado.email
    }
    const { URL } = url()
    const [isOpen, setIsOpen] = useState( false )
    const [contactos, setContactos] = useState([])
    const [formContacto, setFormContacto] = useState( contactoInicial )
    const [pk_contacto, setPk_contacto] = useState( 0 )
    const [cargando, setCargando] = useState( false )



    // funciones
    const traerContactos = () => {

        var fd = new FormData()
        fd.append("funcion", "traerContactos")
        fd.append("correo", objLogueado.email)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            setContactos( e )
        })
        .catch( a => {
            elToast('Hay un error al traer tu lista de contactos.', 'error')
        })

    }


    const guardarContacto = () => {

        setCargando( true )
        fetch( URL, {
            method: 'post',
            body: JSON.stringify({ ...formContacto, pk_contacto })
        })
        .then( res => res.json() )
        .then( function (d) {

            if ( pk_contacto === 0 ) {
                setFormContacto( contactoInicial )
            }

            if ( d.codigo === 1 ) {
                traerContactos()
                elToast( d.mensaje )
            } else {
                elToast( d.mensaje, 'error' )
            }
        })
        .catch( a => {
            elToast("Error al guardar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.", "error")
        })
        .finally( () => setCargando( false ) )
    }

    const abrirModal = ( borrar_pk = true ) => {
        setIsOpen( true )
        if ( borrar_pk ) {
            setPk_contacto( 0 )
        }
    }

    const cerrarModal = () => {
        setIsOpen( false )
        setFormContacto( contactoInicial )
    }

    function borrarContacto( pk_contacto ) {
        if ( pk_contacto && window.confirm("El registro será eliminado.") ) {
            fetch( URL, {
                method: 'post',
                body: JSON.stringify({ pk_contacto: pk_contacto, funcion: 'borrarContacto' })
            })
            .then( res => res.json() )
            .then( function (d) {
                if ( d.codigo === 1 ) {
                    traerContactos()
                    elToast( 'Eliminado con éxito' )
                } else {
                    elToast( d.mensaje, 'info' )
                }
            })
            .catch( a => {
                elToast("Error al eliminar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.", "error")
            })
        }
    }

    function llenarFormContacto( e ) {
        setFormContacto({
            funcion: 'guardarContacto',
            nombre: e.nombre,
            telefono: e.telefono,
            correo: objLogueado.email
        })
        setPk_contacto( e.pk_contacto )
        abrirModal( false )
    }


    // useEffects
    useEffect(() => {
        traerContactos()
        // eslint-disable-next-line
    }, [])


    return {
        isOpen, abrirModal, cerrarModal, contactos,
        guardarContacto, setFormContacto, formContacto,
        llenarFormContacto, cargando, borrarContacto
    }
}

export default useContactosEmergencia
